import { useCallback } from 'react';

interface TrackingEventPayload {
  sessionId?: string;
  eventType: string;
  elementId: string;
  metadata?: Record<string, any>;
}

export function useTracking() {
  const trackEvent = useCallback((payload: TrackingEventPayload) => {
    let sessionId = localStorage.getItem('landing_session_id');
    if (!sessionId) {
      sessionId = 'sess_' + Math.random().toString(36).substr(2, 9);
      localStorage.setItem('landing_session_id', sessionId);
    }

    const data = {
      ...payload,
      sessionId: payload.sessionId || sessionId,
    };

    const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:3333';

    fetch(`${apiUrl}/chat/public/events`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    }).catch((err) => {
      console.warn('[Tracking] Falha ao registrar evento:', err);
    });
  }, []);

  return { trackEvent };
}
